import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../../core/services/cra-esn/cra-esn.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  serverError,
  successAddworkfloww,
} from './../../../../../core/models/messages';
import { EsnpermissionService } from './../../../../../core/services/esnpermission/esnpermission.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-update-workflow',
  templateUrl: './update-workflow.component.html',
  styleUrls: ['./update-workflow.component.css'],
})
export class UpdateWorkflowComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  listrole: any;

  id = this.activatedRoute.snapshot.params['id'];
  roleConsultant:string="Consultant"
  state = [
    { id: '1', name: 'Validé' },
    { id: '2', name: 'Rejeté' },
  ];
  selectedworkflow: any;
  private unsubscribeAll: Subject<void> = new Subject();
  listAvailableConsultant : any
  idsInWorkflow : any[] = []
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private roleservice: EsnpermissionService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.getId();
    this.getWorkflowById();
    this.getWorkflowConsultants()
    this.getListrole();
    this.updateRoleValidators();
  }
  createFormssubWorkFlows(data?: any, index? : number) {    
    return this.formBuilder.group({
      id: [data ? data.uuid : ''],
      role_id: [data ? data.role_id : null],
      step: [data ? data.step : index? index : 1],
    });
  }

  validateUniqueRole(index: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const subWorkFlowTimeSheets = this.formWorkFlow?.get('sub_workflow_cras') as FormArray;
      const selectedRoleId = control.value;
        
      if (!selectedRoleId) {
        return null;
      }
  
      let isDuplicate = false;
      subWorkFlowTimeSheets?.controls.forEach((formGroup, i) => {
        if (i !== index && formGroup.get('role_id')?.value === selectedRoleId) {
          isDuplicate = true;
        }
      });
  
      return isDuplicate ? { duplicateRole: true } : null;
    };
  }

  createWorkFlowForm(data?: any) {    
    return this.formBuilder.group({
      workflow_id: this.id,
      consultant_ids: [Array.isArray(data?.consultant_id) ? data?.consultant_id : [data?.consultant_id].filter(Boolean)],
      type: [data?.type || null],
      sub_workflow_cras: this.formBuilder.array(
        Array.isArray(data?.sub_workflow_cras
        ) && data?.sub_workflow_cras.length
          ? data.sub_workflow_cras.map((item: any) =>
              this.createFormssubWorkFlows(item)
            )
          : [this.createFormssubWorkFlows()],
          this.duplicateRoleValidator()
      ),
    });
  }

  /* create workflow general*/

  updateWorkflow() {
    this.spinner.show();
    let formData = this.formWorkFlow.value;
    formData.sub_workflow_cras = this.updateSubWorkflows(formData.sub_workflow_cras)
    const sub_workflow_cras = formData.sub_workflow_cras;
    for (let i = 0; i < sub_workflow_cras.length; i++) {
      const subWorkflow = sub_workflow_cras[i];
      if (!subWorkflow.id) {
        delete subWorkflow.id;
      }
    }

    this.serviceCraEsn
      .createWorkFlowForm(formData)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', formData);
          this.spinner.hide();

          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
          this.router.navigate(['/cra/list-workflow']);
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }
  updateRoleValidators(): void {
    const sub_workflow_cras = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    
    sub_workflow_cras.controls.forEach((formGroup, index) => {
      formGroup.get('role_id')?.setValidators(this.validateUniqueRole(index));
      formGroup.get('role_id')?.updateValueAndValidity();  
    });
  }
  addsubWorkFlows(): void {
    const subWork = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    const newFormGroup = this.createFormssubWorkFlows(null, subWork.length + 1);
    subWork.push(newFormGroup);
    this.updateRoleValidators();
  }

  removesubWorkFlows(index: number) {
    const sub_workflow_cras = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    if (sub_workflow_cras.length > 1) {
      sub_workflow_cras.removeAt(index);
    }
    this.updateRoleValidators();
  }
  get subWorkFlowsControls(): AbstractControl[] {
    return (this.formWorkFlow.get('sub_workflow_cras') as FormArray)?.controls || [];
  }
  ResetForm() {
    const subWorkflowArray = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    subWorkflowArray.clear();
    subWorkflowArray.push(this.createFormssubWorkFlows(undefined, 0));
  }

  redirectListWorkflow(){
    this.router.navigateByUrl('/cra/list-workflow');
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
      },
    });
  }
  getListrole() {
    this.roleservice.getlisterolesUpdate().subscribe({
      next: (response) => {
        if (response.data) {
          const roles = response.data.data;          
          this.listrole = roles?.filter((role: { hasUsers: boolean; }) => role.hasUsers === true)
        }
      },
      error: (error) => {
        console.error('Error fetching roles: ', error);
      },
    });
  }
  getWorkflowById() {
    this.spinner.show();
    this.serviceCraEsn
      .getWorkflowdetail(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.selectedworkflow = res.data;
          this.formWorkFlow = this.createWorkFlowForm(this.selectedworkflow);
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  updateSubWorkflows(subWorkflows: any[]): any[] {
    subWorkflows = subWorkflows.map((workflow: any, index: number) => ({
      ...workflow,
      step: index + 1,
    }));
    return subWorkflows;
  }

  duplicateRoleValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const formArray = control as FormArray;
      const roles = formArray.controls.map(group => group.get('role_id')?.value);
      if (roles.length > 0 && roles[0] === null) {
        roles.shift();
      }
      const duplicates = roles.filter((role, index) => roles.indexOf(role) !== index);
      const nullRolesCount = roles.filter(role => role === null).length;
      const errors: any = {};

      if (duplicates.length > 0) {
        errors['duplicateRole'] = true;
      }
      
      if (nullRolesCount > 0) {
        errors['multipleNullRole'] = true;
      }      
      return Object.keys(errors).length > 0 ? errors : null;
    };
  }

  getWorkflowConsultants() {
    this.spinner.show();
    this.serviceCraEsn
      .getUpdatedWorkflowConsultants( this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listAvailableConsultant = res.data;
          this.updateConsultantIds();
          this.formatConsultantsNames()
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  formatConsultantsNames() {
    this.listAvailableConsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }

/**
 * Updates the `consultant_ids` control in the form with the IDs of consultants 
 * who have `in_workflow` set to true.
 */
    updateConsultantIds() {
      if (Array.isArray(this.listAvailableConsultant)) {
            this.idsInWorkflow = this.listAvailableConsultant
              .filter((consultant) => consultant.in_workflow === true)
              .map((consultant) => consultant.uuid);              
          // Update the consultant_ids form control
          this.formWorkFlow.patchValue({ consultant_ids: this.idsInWorkflow });
      }
    }

    disableBtnSave() : boolean{
      return (this.selectedworkflow?.type === '2' && this.formWorkFlow.get('consultant_ids')?.value?.length < 1) || this.disableAddSelect()
    }

    showDisableTooltip() : boolean{
      const duplicateRole = this.formWorkFlow.get('sub_workflow_cras')?.hasError('duplicateRole') ? true : false
      const multipleNullRole = this.formWorkFlow.get('sub_workflow_cras')?.hasError('multipleNullRole') ? true : false
      const consultantsError = this.selectedworkflow?.type === '2' && this.formWorkFlow.get('consultant_ids')?.value?.length < 1
      return !duplicateRole && ( consultantsError || multipleNullRole)  
    }

    disableAddSelect() : boolean{
      const subWorkflow = this.formWorkFlow.get('sub_workflow_cras')
      const duplicateRole = subWorkflow?.hasError('duplicateRole') ? true : false
      const multipleNullRole = subWorkflow?.hasError('multipleNullRole') ? true : false
      const hasEmptySelect = subWorkflow?.value?.filter((element: { role_id: any; }) => element.role_id === null)?.length > 1
  
      return duplicateRole || multipleNullRole || hasEmptySelect
    }

}
